import { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Palette } from '@/constants/theme';

/**
 * Edge-anchored action bar. Use for save / commit buttons on long forms
 * so the user never has to scroll to find the primary action.
 *
 * Implementation note: `position: 'absolute'` pinned to bottom 0, with
 * SafeAreaInsets-aware bottom padding so iOS home-indicator + Android
 * gesture nav don't overlap the button. The form's ScrollView should
 * add ~96px of `paddingBottom` so trailing content can scroll above the
 * bar instead of being permanently covered.
 */
export function StickyBottomBar({ children }: { children: ReactNode }) {
  const insets = useSafeAreaInsets();
  return (
    <View
      pointerEvents="box-none"
      style={[
        styles.wrap,
        { paddingBottom: Math.max(insets.bottom, 12) + 8 },
      ]}>
      <View style={styles.bar}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    paddingHorizontal: 16,
    paddingTop: 10,
    backgroundColor: Palette.sand,
    borderTopWidth: 1,
    borderTopColor: Palette.line,
  },
  bar: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
});
